import { useState } from "react";
// import logoo from "../assets/logo/imdady_logo.png";
import { BsPersonVcard } from "react-icons/bs";
import { AiOutlineDashboard } from "react-icons/ai";
import { CiSettings } from "react-icons/ci";
import { IoHomeOutline } from "react-icons/io5";
import { FiTruck } from "react-icons/fi";
import { FaRegFile } from "react-icons/fa";
import { FaChartLine } from "react-icons/fa";
import { IoMdDesktop } from "react-icons/io";
import { FaRegWindowRestore } from "react-icons/fa6";
import { BsUniversalAccessCircle } from "react-icons/bs";
import { FaRegMoneyBillAlt } from "react-icons/fa";
import { HiOutlinePencilSquare } from "react-icons/hi2";
import { LiaComments } from "react-icons/lia";
import { IoPricetagsOutline } from "react-icons/io5";
import { FaRegTrashCan } from "react-icons/fa6";
import { PiUsersThreeLight } from "react-icons/pi";
import { LiaTasksSolid } from "react-icons/lia";
import { GoDot } from "react-icons/go";
import { PiForkKnife } from "react-icons/pi";
import SidenavItem from "./SidenavItem";

export default function SidenavNew() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [open, setOpen] = useState(true);
  const [hoverOpen, setHoverOpen] = useState(false);
  const Menus = [
    {
      title: "Home",
      icon: <IoHomeOutline className="text-2xl block float-left" />,
      link: "home",
    },
    {
      title: "Dashboard",
      icon: <AiOutlineDashboard className="text-2xl block float-left" />,
      link: "dashboard",
      // commingSoon: true,
    },
    {
      title: "Setting",
      icon: <CiSettings className="text-2xl block float-left" />,
      submenu: true,
      submenuItems: [
        { title: "Setting", link: "setting" },
        { title: "Language", link: "language" },
      ],
    },
    {
      title: "Items",
      submenu: true,
      icon: <PiForkKnife className="text-2xl block float-left" />,
      submenuItems: [
        { title: "Ingredient Categories", link: "ingredientCategory" },
        { title: "Ingredient Units", link: "units" },
        { title: "Ingredients", link: "ingredients" },
        { title: "Add Ons", link: "modifiers" },
        { title: "Main Categories", link: "foodMenuCategories" },
        { title: "Sub Categories", link: "foodMenuSubCategories" },
        { title: "VATs", link: "VATs" },
        { title: "Items", link: "foodMenus" },
        { title: "Deals", link: "deals" },
      ],
    },
    {
      title: "Management",
      icon: <BsPersonVcard className="text-2xl block float-left" />,
      submenu: true,
      submenuItems: [
        {
          title: "Subscriptions Management",
          link: "subscription-managment",
          commingSoon: true,
        },
        { title: "Printer", link: "printer", commingSoon: true },
        { title: "Tables", link: "tables" },
        { title: "Return", link: "return", commingSoon: true },
        { title: "Deposit", link: "deposite", commingSoon: true },
        { title: "Copy Items", link: "copy-items", commingSoon: true },
        { title: "Clean database", link: "cleanDatabase", commingSoon: true },
      ],
    },
    {
      title: "Delivery",
      icon: <FiTruck className="text-2xl block float-left" />,
      submenu: true,
      submenuItems: [
        { title: "Rider Order", link: "listorder", commingSoon: true },
      ],
    },
    {
      title: "Outlet",
      icon: <CiSettings className="text-2xl block float-left" />,
      link: "outlet",
      // commingSoon: true,
    },
    {
      title: "Reporting",
      icon: <FaRegFile className="text-2xl block float-left" />,
      link: "reporting",
      // commingSoon: true,
    },
    {
      title: "All Sales",
      icon: <FaChartLine className="text-2xl block float-left" />,
      submenu: true,
      submenuItems: [
        { title: "POS Sales", link: "allsales" },
        { title: "Online Sales", link: "weborder" },
      ],
    },
    {
      title: "Screens",
      icon: <IoMdDesktop className="text-2xl block float-left" />,
      submenu: true,
      submenuItems: [
        { title: "POS", link: "/POS/main" },
        { title: "Kitchen", link: "kitchen", commingSoon: true },
        // { title: "Bar", link: "barPanel" },
        { title: "Waiter", link: "waiter", commingSoon: true },
      ],
    },
    {
      title: "E-Commerce",
      icon: <FaRegWindowRestore className="text-2xl block float-left" />,
      submenu: true,
      submenuItems: [
        { title: "Sms Module", link: "smsMobile", commingSoon: true },
        { title: "Payment Gateway", link: "paymentGateway", commingSoon: true },
        { title: "Banners", link: "bannersetting" },
        { title: "Top Banner", link: "topbanner" },
        { title: "Qrcode", link: "qrCode" },
        { title: "Order Type", link: "ordertype" },
        { title: "Web Setting", link: "webSetting", commingSoon: true },
        { title: "Mail Config", link: "mailConfig", commingSoon: true },
        { title: "Social Media", link: "socialmedia", commingSoon: true },
      ],
    },
    {
      title: "Accounting",
      icon: <BsUniversalAccessCircle className="text-2xl block float-left" />,
      submenu: true,
      submenuItems: [{ title: "Setup", link: "setup", commingSoon: true }],
    },
    {
      title: "Promotion",
      icon: <FaRegMoneyBillAlt className="text-2xl block float-left" />,
      submenu: true,
      submenuItems: [
        { title: "Coupon", link: "coupon" },
        { title: "Credit Card", link: "creditCard" },
        { title: "Subscriptions", link: "subscription", commingSoon: true },
        { title: "Loyalty", link: "loyalty" },
        { title: "Product discount", link: "productdiscount" },
        { title: "Category discount", link: "categorydiscount" },
      ],
    },
    {
      title: "Customer Feedback",
      icon: <HiOutlinePencilSquare className="text-2xl block float-left" />,
      link: "customer-feedback",
      commingSoon: true,
    },
    {
      title: "Feedback",
      icon: <LiaComments className="text-2xl block float-left" />,
      link: "feedback",
      commingSoon: true,
    },
    {
      title: "Purchase",
      icon: <IoPricetagsOutline className="text-2xl block float-left" />,
      submenu: true,
      submenuItems: [
        { title: "Add Purchase", link: "purchase" },
        { title: "Inventory", link: "inventory", commingSoon: true },
        {
          title: "Inventory Adjustments",
          link: "inventoryAdjustment",
          commingSoon: true,
        },
        { title: "Expense Category", link: "expensescategory" },
        { title: "Expense", link: "expenses" },
      ],
    },
    {
      title: "Waste",
      icon: <FaRegTrashCan className="text-2xl block float-left" />,
      link: "waste",
      commingSoon: true,
    },
    {
      title: "User Section",
      icon: <PiUsersThreeLight className="text-2xl block float-left" />,
      submenu: true,
      submenuItems: [
        { title: "Companies", link: "companies", commingSoon: true },
        { title: "Suppliers", link: "suppliers" },
        { title: "Vendor", link: "vendor" },
        { title: "Customers", link: "customer", commingSoon: true },
        // { title: "Supplier Due Payment", link: "supplierPayment" },
        // { title: "Customer Due Receive", link: "customerReceive" },
        // { title: "Attendance", link: "attendance" },
      ],
    },
    {
      title: "Role Management",
      icon: <LiaTasksSolid className="text-2xl block float-left" />,
      submenu: true,
      submenuItems: [
        {
          title: "General Settings",
          link: "generalSetting",
          commingSoon: true,
        },
        { title: "User Management", link: "manageUser" },
        // { title: "Change Profile", link: "changeProfile" },
        // { title: "Change Pasword", link: "changePassword" },
        // { title: "Logout", link: "" },
      ],
    },
  ];
  return (
    <>
      <div className={`${open ? "w-72" : "w-20"} flex`}>
        <div
          className={`${
            hoverOpen || open ? "w-72" : "w-20"
          } p-5 pt-9  bg-gray  duration-300 h-screen fixed top-0 left-0 bottom-0 overflow-y-auto z-10 bg-white dashboard-sidenav`}
          onMouseEnter={() => setHoverOpen(true)}
          onMouseLeave={() => setHoverOpen(false)}
        >
          <div
            className={`inline-flex ${
              hoverOpen || open ? "w-72" : "w-20"
            } transition-all px-4 py-4 justify-between items-center fixed top-0 left-0 bg-white z-10`}
          >
            <div className="inline-flex gap-2">
              <img
                className={`object-contain ${
                  hoverOpen || open ? "" : "mt-[0.34rem]"
                }`}
                src="/assets/logo/imdady_logo_small.png"
                alt=""
              />
              <img
                className={`${hoverOpen || open ? "" : "hidden"} w-24`}
                src="/assets/logo/imdady_logo.png"
                alt=""
              />
            </div>
            <span className={`${hoverOpen || open ? "" : "hidden"}`}>
              <label
                className="relative flex items-center p-3 rounded-full cursor-pointer"
                htmlFor="customStyle"
              >
                <input
                  type="checkbox"
                  className="before:content[''] peer relative h-4 w-4 cursor-pointer appearance-none rounded-full border border-gray-900/20 bg-gray-900/10 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-6 before:w-6 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-gray-400 checked:bg-gray-400 checked:before:bg-gray-400 hover:scale-105 hover:before:opacity-0"
                  id="customStyle"
                  onChange={(e) => setOpen(e.target.checked)}
                  defaultChecked
                />
                <span className="absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                  <GoDot className="h-5 w-5" />
                </span>
              </label>
            </span>
          </div>
          <ul className="pt-2 mt-8">
            {Menus.map(
              (menu, index) =>
                user?.user.module_access &&
                JSON.parse(user?.user.module_access).includes(menu.title) && (
                  <SidenavItem
                    key={index}
                    menu={menu}
                    open={open}
                    hoverOpen={hoverOpen}
                    user={user}
                  />
                )
            )}
          </ul>
        </div>
      </div>
    </>
  );
}
